import { useState } from 'react'
import { apiService } from '../services/api'
import { Benefit, BenefitFormData } from '../types'

export const useBenefits = () => {
 const [benefits, setBenefits] = useState<Benefit[]>([])
 const [isLoading, setIsLoading] = useState(true)
 const [error, setError] = useState<string | null>(null)
 const [pagination, setPagination] = useState({
 page: 1,
 limit: 50,
 total: 0,
 totalPages: 0
 })

 const fetchBenefits = async (params?: {
 page?: number
 limit?: number
 search?: string
 }) => {
 try {
 setIsLoading(true)
 setError(null)
 const response = await apiService.getBenefits(params)
 
 if (response && typeof response === 'object' && 'benefits' in response) {
 setBenefits(response.benefits || [])
 if (response.pagination) {
 setPagination(response.pagination)
 }
 } else if (Array.isArray(response)) {
 setBenefits(response)
 } else {
 setBenefits([])
 }
 } catch (err) {
 console.error('Erro ao carregar benefícios:', err)
 setError('Erro ao carregar benefícios. Tente novamente.')
 setBenefits([])
 } finally {
 setIsLoading(false)
 }
 }

 const createBenefit = async (benefitData: BenefitFormData) => {
 try {
 const newBenefit = await apiService.createBenefit(benefitData)
 if (newBenefit) {
 setBenefits(prev => [newBenefit, ...prev])
 return newBenefit
 }
 throw new Error('Benefício criado mas sem dados retornados')
 } catch (err) {
 console.error('Erro ao criar benefício:', err)
 setError('Erro ao criar benefício. Tente novamente.')
 throw err
 }
 }

 const updateBenefit = async (id: string, benefitData: Partial<BenefitFormData>) => {
 try {
 const updatedBenefit = await apiService.updateBenefit(id, benefitData)
 if (updatedBenefit) {
 setBenefits(prev => prev.map(benefit => benefit.id === id ? updatedBenefit : benefit))
 return updatedBenefit
 }
 throw new Error('Benefício atualizado mas sem dados retornados')
 } catch (err) {
 console.error('Erro ao atualizar benefício:', err)
 setError('Erro ao atualizar benefício. Tente novamente.')
 throw err
 }
 }

 const deleteBenefit = async (id: string) => {
 try {
 await apiService.deleteBenefit(id)
 setBenefits(prev => prev.filter(benefit => benefit.id !== id))
 } catch (err) {
 console.error('Erro ao deletar benefício:', err)
 setError('Erro ao deletar benefício. Tente novamente.')
 throw err
 }
 }

 // Removido useEffect automático - carregamento deve ser manual quando necessário

 return {
 benefits,
 isLoading,
 error,
 pagination,
 fetchBenefits,
 createBenefit,
 updateBenefit,
 deleteBenefit
 }
}

